import { PageType } from "@/types";
import Ocean from "./Ocean";

export const WaterScene = ({ animationIsPlaying, animationTime, page }: { animationIsPlaying: boolean; animationTime: number; page: PageType }) => {
	if (page && page.model && !page.model.name.includes("Marlin")) {
		return null;
	}

	// console.log(object);

	return (
		<>
			{/**
			 * Wasseroberfläche
			 */}
			<Ocean animationIsPlaying={animationIsPlaying} />
		</>
	);
};
